import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import DocumentationSidebar from '../component/DocumentationSidebar';
import Searchbar from '../component/SearchBar';
import image001 from '../assetes/images/survey/action-in-calculator-list/image001.png';
import image002 from '../assetes/images/survey/action-in-calculator-list/image002.png';
import image003 from '../assetes/images/survey/action-in-calculator-list/image003.png';
import image004 from '../assetes/images/survey/action-in-calculator-list/image004.png';
import image005 from '../assetes/images/survey/action-in-calculator-list/image005.png';
import image006 from '../assetes/images/survey/action-in-calculator-list/image006.png';
import image007 from '../assetes/images/survey/action-in-calculator-list/image007.png';
import image008 from '../assetes/images/survey/action-in-calculator-list/image008.png';
import image009 from '../assetes/images/survey/action-in-calculator-list/image009.png';
import image010 from '../assetes/images/survey/action-in-calculator-list/image010.png';
import image011 from '../assetes/images/survey/action-in-calculator-list/image011.png';
import image012 from '../assetes/images/survey/action-in-calculator-list/image012.png';
import image013 from '../assetes/images/survey/action-in-calculator-list/image013.png';
import image014 from '../assetes/images/survey/action-in-calculator-list/image014.png';
import image015 from '../assetes/images/survey/action-in-calculator-list/image015.png';
import image016 from '../assetes/images/survey/action-in-calculator-list/image016.png';
import image017 from '../assetes/images/survey/action-in-calculator-list/image017.png';
import image018 from '../assetes/images/survey/action-in-calculator-list/image018.png';
import image019 from '../assetes/images/survey/action-in-calculator-list/image019.png';
import image020 from '../assetes/images/survey/action-in-calculator-list/image020.png';
import image021 from '../assetes/images/survey/action-in-calculator-list/image021.png';
import image022 from '../assetes/images/survey/action-in-calculator-list/image022.png';
import image023 from '../assetes/images/survey/action-in-calculator-list/image023.png';
import image024 from '../assetes/images/survey/action-in-calculator-list/image024.png';
import image025 from '../assetes/images/survey/action-in-calculator-list/image025.png';

export default function ActionInCalculatorList() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />


                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap document-page-wrap'>
                            <Searchbar containerSelector=".search-scope" />
                            <div className='search-scope mt-4'>
                                <h1 className='mt-0 text-primary'>Actions in Calculator List</h1>
                                <p className='header-para'>
                                    The Calculator module is designed to enable users to build and manage ROI (Return on Investment) calculators that demonstrate the business value or potential savings a customer can expect from using a specific product or solution.
                                </p>
                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Navigating to Actions

                                    </div>
                                    <div className="card-body">

                                        <ul>

                                            <li> When you click on the three-dot button in the Calculator list table, a dropdown with available actions will open. By clicking on any action, a different operation will be performed as explained below.
                                                <img src={image001} alt="actions" className='pt-10 pb-10 img-fluid' />
                                            </li>

                                        </ul>
                                    </div>
                                </div>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Calculations & Logics
                                    </div>
                                    <div className="card-body">
                                        <img src={image002} alt="Calculations & Logics" className='img-fluid pt-10 pb-10' />

                                        <p> Allows you to configure or modify the backend formulas, conditions, and logical flows of the ROI calculator.
                                            Useful for applying custom business rules and computation logic. Onclick on Calculations & Logics action ,
                                            user redirected to this page. Mainly divided into table list and create button which will explain in details in
                                            <NavLink to="/admin/ducumentation/surveys/document-calculationlogic"> Calculation Logic</NavLink>
                                        </p>

                                    </div>
                                </div>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Custom Variable
                                    </div>
                                    <div className="card-body">
                                        <img src={image017} alt="Calculations & Logics" className='img-fluid pt-10 pb-10' />

                                        <p> This section allows you to manage custom variables used within logic calculations, form conditions, or dynamic rules.</p>
                                        <p>Custom Variables provide a way to assign dynamic values based on conditions defined in the Stage module. These variables are standalone and have unique names that can be used to reference and utilize their values throughout the system.
                                            Explain in details in  <NavLink to="/admin/ducumentation/surveys/document-customvariable">Custom Variable</NavLink>  </p>

                                       

                                    </div>
                                </div>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Publish, Duplicate and Delete Actions
                                    </div>
                                    <div className="card-body">

                                        <p><b>Publish</b></p>
                                        <ul>
                                            <li>Purpose : Makes the item live and available for use.</li>
                                            <li>Use case : Once your logic or form is ready, click Publish to activate it.</li>
                                        </ul>
                                        <p><b>Duplicate</b></p>
                                        <img src={image024} alt="Duplicate" className='pt-10 pb-10' />
                                        <ul>
                                            <li>Purpose : Creates an exact copy of the current item.</li>
                                            <li>Use case : Useful when you want to reuse an existing item with slight modifications, without recreating it from scratch.</li>
                                        </ul>
                                        <p><b>Delete</b></p>
                                        <img src={image025} alt="Delete" className='pt-10 pb-10' />

                                        <ul>
                                            <li>Purpose : Permanently removes the item.</li>
                                            <li>Use case : Use this when the item is no longer needed. Typically prompts for confirmation to prevent accidental deletion.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div >
            </div >
        </>
    )
}
